// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iQGN","index":"styles_index__2zKVl"};